import { useCallback, useMemo } from 'react'
import { Webhook } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchOutgoingWebhooks, AUTO_STR as S, type OutgoingWebhookRow } from './automationApi'

/**
 * A26.09 — Исходящие webhook (fired by automation, read-only). Dormant until
 * `/admin/automation/webhooks` ships. Placeholder permission USERS_VIEW.
 */
export function OutgoingWebhooksScreen() {
  const columns = useMemo<AdminColumn<OutgoingWebhookRow>[]>(
    () => [
      { key: 'url', header: S.url, type: 'text' },
      { key: 'event', header: S.event, type: 'text' },
      { key: 'active', header: S.active, type: 'text' },
      { key: 'last_status', header: S.lastStatus, type: 'number' },
      { key: 'failures', header: S.failures, type: 'number' },
    ],
    [],
  )
  const fetcher = useCallback(fetchOutgoingWebhooks, [])
  return (
    <>
      <PageHeader title={S.outgoing} screenId="A26.09" />
      <DataTable<OutgoingWebhookRow>
        screenId="A26.09"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Webhook size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
